import React, { useState, useEffect } from 'react';
import { Spin, Table, message, Card } from 'antd';
import { propertiesColumns } from '../../data/Columns';
import { getRecommendation } from '../../data/Data';


const PropertiesTable = ({ data = {}, title }) => {
    const [propertiesData, setPropertiesData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!data || Object.keys(data).length === 0) {
            setLoading(false); // Stop the spinner if no data is provided
            return;
        }
      
        const fetchData = async () => {
            try {
                const tableData = Object.keys(data).map((key, index) => ({
                    key: index,
                    property: key.toUpperCase(),
                    value: data[key],
                    recommendation: getRecommendation(key, data[key])
                }));
        
                setPropertiesData(tableData);
                setLoading(false);
            } catch (err) {
                message.error(err.message || "Failed to process data.");
                setLoading(false);
            }
        };
      
        fetchData();
    }, [data]);
      

    return (
        <Card title={title} variant="borderless" style={{ width: '100%', margin: '20px auto' }}>
            <Spin spinning={loading} size="large">
                <div style={{ width: '100%' }}>
                    <Table 
                        columns={propertiesColumns}   
                        dataSource={propertiesData.length ? propertiesData : []} 
                        rowKey={(record) => record['key']}    
                        pagination={false}                         
                        size='middle' 
                        scroll={{ x: 300 }} 
                    />   
                </div>
            </Spin>
        </Card>
    );
}

export default PropertiesTable;
